import { render, staticRenderFns } from "./CompanyBilling.vue?vue&type=template&id=cb2add80&"
import script from "./CompanyBilling.vue?vue&type=script&lang=ts&"
export * from "./CompanyBilling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb2add80')) {
      api.createRecord('cb2add80', component.options)
    } else {
      api.reload('cb2add80', component.options)
    }
    module.hot.accept("./CompanyBilling.vue?vue&type=template&id=cb2add80&", function () {
      api.rerender('cb2add80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyBilling.vue"
export default component.exports